<ng-container *transloco="let _t">

<!-- MODE D'EMPLOI POUR LES AUDITEURS -->
<div *ngIf="isAuditor && showManual" class="col-10 instructions">
	<h2>{{ _t('audit-questionnary-h2-0') }}</h2>
	<p>{{ _t('audit-questionnary-p-0') }}</p>
	
	<p> {{ _t('audit-questionnary-p-1') }}</p>
	<p> {{ _t('audit-questionnary-p-2') }}</p>

	<p>{{ _t('audit-questionnary-p-3') }}</p>

	<p></p>

	<p class="text-end"><button mat-raised-button (click)="showManual=false"><mat-icon>check</mat-icon>OK</button></p>
</div>

<!-- MODE D'EMPLOI POUR LES SIMPLES UTILISATEURS -->
<div *ngIf="!isAuditor && showManual" class="col-10 instructions">
	<h2>{{ _t('audit-questionnary-h2-0') }}</h2>
	<p>{{ _t('audit-questionnary-p-6') }}</p>

	<p>{{ _t('audit-questionnary-p-3') }}</p>

	<p class="text-end"><button mat-raised-button (click)="showManual=false"><mat-icon>check</mat-icon>OK</button></p>

</div> <!-- /MODE D'EMPLOI -->


<div class="row h-100">
	<div id="summary" class="col-3" *ngIf="showSummary">

		<div class="progression">
			<mat-progress-spinner
				[value]="diagnostic.ratio"
				[diameter]="30"
				[mode]="spinnerRunning ? 'indeterminate' : 'determinate'"
				>
			</mat-progress-spinner>
			{{progression}}  {{ _t('indicateurs remplis') }}
		</div>
		<p>
			<mat-icon (color)="disabled">help</mat-icon> {{ _t('uncompleted')}} <br>
			<mat-icon (color)="disabled">not_interested</mat-icon> {{ _t('unrevelant') }} <br>
			<mat-icon (color)="disabled">done</mat-icon> 
			<!--*ngFor="let slice of allSlices" [ngStyle]="{'color': slice.color}" [title]="_t(slice.name)"-->
				{{ _t('audit-questionnary-legend-completed') }}
		</p>

		<div *ngFor="let chapter of chapters; let chI=index">
			<!--<h3 *ngIf="chapter.indiGroups.length>0">
				Chapitre {{chI+1}} : {{chapter.name}}
			</h3>-->
			<ol class="indiGroups">
				<li *ngFor="let indiGroup of chapter.indiGroups">
				<h4 class="indiGroup">{{indiGroup.name}}</h4>
				<ul class="indicators">
					<li *ngFor="let indicator of indiGroup.indicators"><div *ngIf="indicator!=undefined">
						<mat-icon *ngIf="!indicator.answer.completed" (color)="disabled"
						[title]="_t('uncompleted')">help</mat-icon>
						
						<mat-icon *ngIf="indicator.answer.revelent==0" (color)="disabled"
						[title]="_t('unrevelant')">not_interested</mat-icon>

						<mat-icon *ngIf="indicator.answer.completed && indicator.answer.revelent>0"
						[ngStyle]="{'color': indicator.answer.slice.color}" [title]="_t(indicator.answer.slice.name)">done</mat-icon>
						
						<a (click)="openedIndicator=indicator"
							[ngClass]="{'selected': openedIndicator==indicator}" 
							[class]="indicator.answer.slice.name" >
						{{indicator.name}}</a>
					</div></li>
				</ul>
				</li>
			</ol>
		</div>
	</div>
	
	<audit-questionnary-indicator *ngIf="openedIndicator!=undefined" 
	[class]="showSummary ? 'col-9' : 'col-12'"
		[indicator]="openedIndicator"
		[diagnostic]="diagnostic"
		(change)="setChanged($event)"
	></audit-questionnary-indicator>

</div><!-- left-aligned-->


</ng-container>